import { render } from "./cpt-dataV-decoration.vue?vue&type=template&id=039dbc84"
import script from "./cpt-dataV-decoration.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-decoration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__